import React from "react";

export default React.createContext({
    user   : window.__DATA__._user,
    session: window.__DATA__.session,
});
